import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OpportunityorderService {

  constructor(private httpClient:HttpClient) { }

  public postOpportunityOrder( data: any){

    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    // console.log("inside postOpportunityOrder");
    // console.log(headers);
    return this.httpClient.post<any>('/api/v1/opportunity/order/' , data , {headers}).pipe(catchError(this.errorHandler));
  }

  public updateOpportunityOrder( data: any){

    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    // console.log("inside updateOpportunityOrder");
    // console.log(headers);
    return this.httpClient.put<any>('/api/v1/opportunity/order/' , data , {headers}).pipe(catchError(this.errorHandler));
  }
  

  public deleteOpportunityOrder( id: any){

    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    // console.log("inside updateOpportunityOrder");
    // console.log(headers);
    return this.httpClient.delete<any>('/api/v1/opportunity/order/' + id , {headers}).pipe(catchError(this.errorHandler));
  }

  public retrieveOpportunityOrders(opportunityId: number){
      return this.httpClient.get<any[]>('/api/v1/opportunity/order/for/'+ opportunityId ).pipe(catchError(this.errorHandler));
  }


  findOpportunitiesByCustomerAndProduct(customerId: number, productId: number): Observable<any[]> {
    const payload = { customerId, productId };
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.post<any[]>('/appliances/api/v2/opportunity/findOpportunitiesByCustomerAndProduct/', payload , {headers});
  }

  errorHandler(error: HttpErrorResponse){
    console.log(error.message);
    return throwError(error.message || 'Server Error');
  }

}
